import React from 'react';
import LiveUpdate from '../Mobile/LiveUpdate';

const DashboardHome = () => {
    return (
        <div>
            <h1 className='mt-40 font-bold'>মাদরাসা-এ-জালাল উদ্দীন রুমীর ড্যাশবোর্ড/এডমিন প্যানেল এ স্বাগতম</h1>
            <h2>বাম দিক (কম্পিউটার) অথবা ডান দিকের উপরের কোনা (মোবাইল) থেকে অপশন বাছাই করুন </h2>

            <LiveUpdate/>
        </div>
    );
};

export default DashboardHome;